import React from "react";

import { ValueInput } from "@common/components/Input/ValueInput/ValueInput";
import * as Styled from "@main/pages/Release/views/MetricDetails/ResolutionRate/PriorityRow.styles";

interface PriorityRowProps {
  icon?: React.ReactNode;
  label: string;
  value: number;
  unit?: string;
  step?: number;
  min?: number;
  isError?: boolean;
  error?: string;
  description: string;
  onChange: (value: number) => void;
}

export function PriorityRow({
  icon,
  label,
  value,
  unit,
  step,
  min,
  isError,
  error,
  description,
  onChange,
}: PriorityRowProps) {
  return (
    <Styled.PriorityRowWrapper>
      <Styled.PriorityIconAndInput>
        {icon ? icon : null}
        <ValueInput
          style={{ width: "16rem" }}
          label={label}
          unit={unit}
          value={value}
          step={step}
          min={min}
          isError={isError}
          onChange={onChange}
        />
      </Styled.PriorityIconAndInput>

      <Styled.PriorityDescriptionColumn>
        <Styled.PriorityDescText>{description}</Styled.PriorityDescText>
        {error && <Styled.PriorityError>{error}</Styled.PriorityError>}
      </Styled.PriorityDescriptionColumn>
    </Styled.PriorityRowWrapper>
  );
}
